export { default } from 'features/support/flows/case-form/support-v2-form-page';
